import React, { useEffect, useMemo, useState } from 'react';
import { generateClient } from '@aws-amplify/api';
import { getBookings } from '@/graphql/small-queries';
import { BookedRevenueWidget } from '@/components/widgets/booked-revenue-widget';
import { buildBookedRevenueBookingFilters, buildBookedRevenueMetrics } from '@/utils/bookedRevenue';
import './Widgets.scss';

const client = generateClient();
const BOOKING_SORT = [{ field: 'fh_booked_at', order: 'desc' }];

const BookedRevenueCard = ({ startDate, endDate, selectedPeriod = 'last 30 days' }) => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  const bookingFilters = useMemo(
    () => buildBookedRevenueBookingFilters(startDate, endDate, selectedPeriod),
    [endDate, selectedPeriod, startDate],
  );

  useEffect(() => {
    let mounted = true;

    setLoading(true);
    client
      .graphql({
        query: getBookings,
        variables: { filters: bookingFilters, sorting: BOOKING_SORT },
      })
      .then((response) => {
        if (!mounted) return;
        setBookings(response?.data?.getBookings?.bookings || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error loading bookings:', err);
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [bookingFilters]);

  const metrics = useMemo(() => {
    const revenueMetrics = buildBookedRevenueMetrics(bookings, {
      startDate,
      endDate,
      period: selectedPeriod,
    });

    return {
      ...revenueMetrics,
      miniChartData: revenueMetrics.revenueDailyData,
    };
  }, [bookings, endDate, selectedPeriod, startDate]);

  if (loading) {
    return (
      <div className="bg-white px-4 py-3 rounded-3 shadow-sm dashboard-card" style={{ border: '1px solid #e0e0e0' }}>
        <div className="text-center text-muted py-4">Loading...</div>
      </div>
    );
  }

  return (
    <BookedRevenueWidget
      value={metrics.value}
      change={metrics.change}
      trend={metrics.trend}
      subtitle={metrics.subtitle}
      miniChartData={metrics.miniChartData}
      expandedPath="/BookedRevenueExpanded"
      expandedState={{ defaultPeriod: 'year to date' }}
    />
  );
};

export default BookedRevenueCard;
